export const actions = {
  set_state: 'api_keys/set_state',
  get_api_keys: 'api_keys/get_api_keys',
  create_api_key: 'api_keys/create_api_key',
  delete_api_key: 'api_keys/delete_api_key'
}
